var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95698 13.4536C7.79341 13.4536 7.67073 13.3718 7.58894 13.2082C7.50715 13.0447 7.54804 12.8811 7.67073 12.7584L11.7601 8.66901C11.9237 8.50543 12.1691 8.50543 12.3326 8.66901L16.422 12.7584C16.5447 12.8811 16.5856 13.0447 16.5038 13.2082C16.4629 13.3718 16.2994 13.4536 16.1358 13.4536L7.95698 13.4536Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.50f06f53d47b5e47e8dbe55bd9b6aef0.svg";
export { ForwardRef as ReactComponent };